// extracted by mini-css-extract-plugin
export var content = "FiveColumnSection-module--content--4ad17";
export var group = "FiveColumnSection-module--group--07f1d";
export var groupTitle = "FiveColumnSection-module--groupTitle--3db1e";
export var groupWrapper = "FiveColumnSection-module--groupWrapper--f0331";
export var title = "FiveColumnSection-module--title--ff7d5";